import React, { Fragment } from 'react';
import moment from 'moment';
import {
  EuiSpacer,
  EuiBasicTable,
  EuiDescriptionList,
  EuiFlexItem,
  EuiFlexGroup,
} from 'stable-eui';
import { get } from 'lodash';
import { Tabs } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
import { getMessage } from 'utils';

export default (props) => {
  const tab1Data = get(props.data, 'tab1Data', {});
  const tab2Data = get(props.data, 'tab2Data', []);

  const tab2Columns = [
    {
      field: 'MA_PHIEUGUI',
      name: 'Mã PG',
      sortable: true,
    },
    {
      field: 'MA_BUUCUC_GOC',
      name: 'Bưu cục gốc',
      sortable: true,
    },
    {
      field: 'MA_BUUCUC_PHAT',
      name: 'Bưu cục phát',
      sortable: true,
    },
    {
      field: 'MA_DV_VIETTEL',
      name: 'Dịch vụ',
      sortable: true,
    },
    {
      field: 'TRONG_LUONG',
      name: 'Trọng lượng',
      sortable: true,
    },
    {
      field: 'TONG_TIEN',
      name: 'Tổng tiền',
      sortable: true,
    },
  ];

  const tab2Content = (
    <Fragment>
      <EuiSpacer />
      <EuiBasicTable
        items={tab2Data || []}
        rowHeader="ID"
        noItemsMessage="Không tìm thấy thông tin hiển thị"
        columns={tab2Columns}
      />
    </Fragment>
  );

  const leftTab1 = [
    {
      title: 'Ngày chuyến thư',
      description:
        tab1Data.NGAY_NHAP_MAY &&
        moment(tab1Data.NGAY_NHAP_MAY).format('DD-MM-YYYY HH:mm'),
    },
    {
      title: 'Ngày khởi hành',
      description:
        tab1Data.NGAY_KHOI_HANH &&
        moment(tab1Data.NGAY_KHOI_HANH).format('DD-MM-YYYY HH:mm'),
    },
    {
      title: 'Bưu cục đi',
      description: get(tab1Data, 'MA_BUUCUC_DI', ''),
    },
    {
      title: 'Người ký giao',
      description: get(tab1Data, 'NGUOI_KY_GIAO', ''),
    },
    {
      title: 'Lái xe',
      description: get(tab1Data, 'LAIXE_NAME', ''),
    },

    {
      title: 'Trọng lượng',
      description: get(tab1Data, 'TRONG_LUONG', ''),
    },

    {
      title: 'Tên tuyến',
      description: get(tab1Data, 'TEN_TUYEN', ''),
    },
  ];

  const rightTab1 = [
    {
      title: 'Ghi chú',
      description: get(tab1Data, 'GHI_CHU', ''),
    },

    {
      title: 'Ngày hoàn thành',
      description:
        tab1Data.NGAY_HOAN_THANH &&
        moment(tab1Data.NGAY_HOAN_THANH).format('DD-MM-YYYY HH:mm'),
    },
    {
      title: 'Bưu cục nhận',
      description: get(tab1Data, 'MA_BUUCUC_DEN', ''),
    },
    {
      title: 'Ngày ký',
      description: tab1Data.NGAY_KY || '',
    },
    {
      title: 'Biển số',
      description: get(tab1Data, 'BIENSO', ''),
    },
    {
      title: 'Số tải / kiện',
      description:
        get(tab1Data, 'SL_TAI', 0) + ' / ' + get(tab1Data, 'SL_KIEN', 0),
    },
    {
      title: 'Người gán',
      description: get(tab1Data, 'NGUOI_GAN', ''),
    },
  ];

  return (
    <Tabs defaultActiveKey="1">
      <Tabs.TabPane
        tab={
          <span>
            <CaretRightOutlined />
            {getMessage('shipment_info')}
          </span>
        }
        key="1"
      >
        <EuiFlexGroup style={{ paddingTop: 20 }}>
          <EuiFlexItem>
            <EuiDescriptionList textStyle="reverse" listItems={leftTab1} />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiDescriptionList textStyle="reverse" listItems={rightTab1} />
          </EuiFlexItem>
        </EuiFlexGroup>
      </Tabs.TabPane>
      <Tabs.TabPane
        tab={
          <span>
            <CaretRightOutlined />
            Chi tiết Bill
          </span>
        }
        key="2"
      >
        {tab2Content}
      </Tabs.TabPane>
    </Tabs>
  );
};
